import type { Environment } from '@seddi/scene';
import type { LoadingManager, PMREMGenerator, WebGLRenderer } from '@seddi/three';
import type { EnvironmentGfx } from './environmentTypes';
import { load as loadTexture } from './textureLoader';

/**
 * Load environment.
 * @param desc - Descriptor.
 * @param manager - Loading manager.
 * @param renderer - WebGL renderer.
 * @param generator - PMREM generator.
 */
export const load = async (
  desc: Environment,
  manager: LoadingManager,
  renderer: WebGLRenderer,
  generator: PMREMGenerator,
): Promise<EnvironmentGfx> => {
  // Load equirectangulra texture.
  const equirectangularTexture = await loadTexture(desc.texture, manager, renderer);
  // Generate Prefiltered, Mipmapped Radiance Environment texture.
  const renderTarget = generator.fromEquirectangular(equirectangularTexture);
  const texture = renderTarget.texture;
  return { id: desc.id, isEnvironment: true, texture };
};
